/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import IconBack from '../../../assets/Images/icons/icon-back';
import { Button, Form, Upload, Input, notification } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import GlobalService from '../../../services/Global.service';
import { getBase64 } from '../../../util/util';
import MyCompanyService from '../../../services/MyCompany.service';
import useNotify from '../../../context/Notification/useNotify';
import { useBlocker } from '../../../util/usePrompt';
import ModalDiscardChanges from '../../../components/Shared/modal/discardChanges';
import UserService from '../../../services/UserService';
import { ROUTER } from '../../../constants/router';
export default function AddCompany() {
    const { t } = useTranslation();
    const Navigate = useNavigate();
    const { id } = useParams();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [imageUrl, setImageUrl] = useState();
    const [imageId, setImageId] = useState('');

    const notify = useNotify();

    const [change, setChange] = useState(false);
    const [openChange, setOpenChange] = useState(false);
    const [nextLocation, setNextLocation] = useState(null);
    const [isChangeLocation, setIsChangeLocation] = useState(false);

    useBlocker((nextLocation) => onChangePage(nextLocation), change === true);

    const onChangePage = (nextLocation) => {
        setOpenChange(true);
        setIsChangeLocation(true);
        setNextLocation(nextLocation);
    };
    const handelOk = async () => {
        setOpenChange(false);
        setChange(false);
    };

    const handelOkLocation = async () => {
        setOpenChange(false);
        setChange(false);
        setIsChangeLocation(false);
        await form.resetFields();
        await Navigate(
            nextLocation.location.pathname + nextLocation.location.search
        );
    };
    const onFinish = async (value) => {
        if (!id) {
            try {
                const { data } = await MyCompanyService.createCompany({
                    ...value,
                    companyId: id || null,
                    companyLogoId: imageId,
                });
                if (data?.resultCode === 1) {
                    notify({
                        title: t('common.Success'),
                        description: t('Successfully to submitted'),
                    });
                    setChange(false);
                    setTimeout(async () => {
                        await Navigate(
                            ROUTER.CONFIGURATION.USER_MANAGEMENT + '/my-company'
                        );
                    }, 1300);
                } else {
                    if (data?.errorData?.msg === 'DUPLICATE COMPANY NAME') {
                        form.setFields([
                            {
                                name: 'companyName',
                                errors: [t('MyCompany.ThisCompanyIsExist')],
                            },
                        ]);
                    } else {
                        notify({
                            type: 'error',
                            title: t('common.Fail'),
                            description: t('Failed to submitted'),
                        });
                    }
                }
            } catch (error) {
                if (error?.data?.errorData?.msg === 'DUPLICATE COMPANY NAME') {
                    form.setFields([
                        {
                            name: 'companyName',
                            errors: [t('MyCompany.ThisCompanyIsExist')],
                        },
                    ]);
                } else {
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('Failed to submitted'),
                    });
                }
            }
        } else {
            console.log('edit !');
            try {
                const { data } = await MyCompanyService.updateCompany({
                    ...value,
                    companyId: id || null,
                    companyLogoId: imageId,
                });
                if (data?.resultCode === 1) {
                    notify({
                        title: t('common.Success'),
                        description: t('Successfully to submitted'),
                    });
                    setChange(false);
                    setTimeout(async () => {
                        await Navigate(
                            ROUTER.CONFIGURATION.USER_MANAGEMENT + '/my-company'
                        );
                    }, 1300);
                } else {
                    if (data?.errorData?.msg === 'DUPLICATE COMPANY NAME') {
                        form.setFields([
                            {
                                name: 'companyName',
                                errors: [t('MyCompany.ThisCompanyIsExist')],
                            },
                        ]);
                    } else {
                        notify({
                            type: 'error',
                            title: t('common.Fail'),
                            description: t('Failed to submitted'),
                        });
                    }
                }
            } catch (error) {
                if (error?.data?.errorData?.msg === 'DUPLICATE COMPANY NAME') {
                    form.setFields([
                        {
                            name: 'companyName',
                            errors: [t('MyCompany.ThisCompanyIsExist')],
                        },
                    ]);
                } else {
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('Failed to submitted'),
                    });
                }
            }
        }
    };

    const beforeUpload = (file) => {
        const isJpgOrPng =
            file.type === 'image/jpeg' || file.type === 'image/png';

        if (!isJpgOrPng) {
            notification['error']({
                message: t('COOKIE.YouUploadFile'),
            });
        }

        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isLt2M) {
            notification['error']({
                message: t('COOKIE.ImageMustSmaller'),
            });
        }

        if (isJpgOrPng && isLt2M) {
            handleChange(file);
        }
        return false;
    };

    const uploadButton = (
        <div>
            {loading ? <LoadingOutlined /> : <SvgIconPlus />}
            <div className="mt-2 text-purple">{t('MyCompany.AddLogo')}</div>
        </div>
    );

    const handleChange = async (file) => {
        let fileList = new FormData();
        console.log(file.name);
        fileList.append('image', file);
        fileList.append('fileName', file.name);
        fileList.append('action', 'image-create-application');
        try {
            const { data } = await GlobalService.uploadImage(fileList);
            if (data?.resultData?.imageId) {
                setLoading(false);
                setImageId(data?.resultData?.imageId);
                getBase64(file, (url) => {
                    setImageUrl(url);
                });
            }
        } catch (error) {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (id) {
            getCompanyById(id);
        }
    }, [id]);

    // Role
    const role = UserService.role().toLowerCase();
    const admin = ['admin', 'auditor', 'super admin'].includes(role);

    useEffect(() => {
        if (!admin) {
            Navigate('/not-found');
        }
    }, []);

    const getImage = async (id) => {
        try {
            const { data } = await GlobalService.getImage(id);
            if (data.resultData?.imageId) {
                setImageUrl(
                    `data:image/png;base64,${data.resultData?.imageId}`
                );
            }
        } catch (error) {
            console.log(error);
        }
    };
    const getCompanyById = async (id) => {
        try {
            const { data } = await MyCompanyService.getCompanyById(id);
            if (data?.resultData) {
                const res = data?.resultData;
                form.setFieldsValue({
                    ...data?.resultData,
                    country: data?.resultData?.country || 'Thailand',
                });
                if (res?.companyLogoId) {
                    setImageId(res.companyLogoId);
                    getImage(res.companyLogoId);
                }
            }
        } catch (error) {
            console.log(error);
        }
    };
    return (
        <>
            <div className="title flex">
                <div
                    className="cursor-pointer mr-3"
                    onClick={() => {
                        // setBackAction(true)
                        // navigate('/dc-dpo');
                        Navigate(
                            ROUTER.CONFIGURATION.USER_MANAGEMENT + '/my-company'
                        );
                    }}
                >
                    <IconBack />
                </div>
                <span>
                    {id ? (
                        <>{t('MyCompany.EditMyCompany')}</>
                    ) : (
                        <>{t('MyCompany.AddMyCompany')} </>
                    )}
                </span>
            </div>
            <div className="sub-title mb-2">
                <span className="text-sm text-gray-400">
                    {t('common.Configuration')} / {t('common.UserManagement')} /
                </span>
                <span>
                    {id ? (
                        <>{t('MyCompany.EditMyCompany')}</>
                    ) : (
                        <>{t('MyCompany.AddMyCompany')} </>
                    )}
                </span>
            </div>

            <div className="w-full rounded-md bg-white p-6">
                <Form
                    scrollToFirstError={{
                        behavior: 'smooth',
                        block: 'center',
                    }}
                    layout="vertical"
                    form={form}
                    onFinish={onFinish}
                    onFinishFailed={(value) => {
                        console.log('value failed ', value);
                    }}
                    onFieldsChange={(_, allFields) => {
                        if (allFields.length > 0) {
                            setChange(true);
                        }
                    }}
                    initialValues={{ country: 'Thailand' }}
                >
                    <div
                        className="flex justify-between mb-5 p-2"
                        style={{ borderBottom: '3px solid #F4F6FC' }}
                    >
                        <div className="text-2xl font-semibold pb-2 text-purple">
                            {t('MyCompany.MyCompanyInformation')}
                        </div>

                        <div className="space-x-3 font-sm items-right justify-end">
                            <div className="space-x-4 items-right mb-2 text-right">
                                <Button
                                    size="large"
                                    type="default"
                                    className="text-purple-PHX border-purple-PHX w-32"
                                    onClick={() => {
                                        Navigate(
                                            ROUTER.CONFIGURATION
                                                .USER_MANAGEMENT + '/my-company'
                                        );
                                    }}
                                >
                                    {t('Cancel')}
                                </Button>
                                <Button
                                    size="large"
                                    type="primary"
                                    className="w-32"
                                    htmlType="submit"
                                >
                                    {t('common.Save')}
                                </Button>
                            </div>
                        </div>
                    </div>
                    <div className="p-2">
                        <div className="grid grid-cols-3">
                            <div className="col-span-2 my-1 mr-4">
                                <div className="flex justify-start w-full">
                                    <Form.Item className="mt-4">
                                        <Upload
                                            listType="picture-card"
                                            className="avatar-uploader w-max"
                                            showUploadList={false}
                                            beforeUpload={beforeUpload}
                                            // onChange={handleChange}
                                            // action="https://dev-api.whitefact.co/service-gateway/wfsecure/image"
                                            // headers={{
                                            //     authorization: `Bearer ${accessToken}`,
                                            // }}
                                        >
                                            {imageUrl ? (
                                                <div className="rounded-full flex justify-center items-center avatar">
                                                    <img
                                                        src={imageUrl}
                                                        className="rounded-full object-cover"
                                                        alt="avatar"
                                                    />
                                                </div>
                                            ) : (
                                                uploadButton
                                            )}
                                        </Upload>
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                        <div className="grid grid-cols-3">
                            <div className="col-span-2 my-1 mr-4">
                                <div className="justify-center w-full">
                                    <Form.Item
                                        label={t('Company Name')}
                                        name="companyName"
                                        rules={[
                                            {
                                                required: true,
                                                message: t(
                                                    'errorText.requiredField'
                                                ),
                                            },
                                        ]}
                                    >
                                        <Input
                                            placeholder={t('Company Name')}
                                            size="large"
                                            showCount
                                            maxLength={100}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label={t('MyCompany.PolicyURL')}
                                        name="policyUrl"
                                        rules={[
                                            {
                                                required: false,
                                                message: t(
                                                    'errorText.requiredField'
                                                ),
                                            },
                                            {
                                                pattern: new RegExp(
                                                    /[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)?/gi
                                                ),
                                                message: t(
                                                    'MyCompany.PolicyURLNotValidURL'
                                                ),
                                            },
                                        ]}
                                    >
                                        <Input
                                            placeholder={t(
                                                'MyCompany.PolicyURL'
                                            )}
                                            size="large"
                                        />
                                    </Form.Item>
                                    <div className="grid grid-cols-2 gap-4">
                                        <Form.Item
                                            label={t(
                                                'MyCompany.PublicContactEmail'
                                            )}
                                            name="publicContactEmail"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: t(
                                                        'errorText.requiredField'
                                                    ),
                                                },
                                                {
                                                    type: 'email',
                                                    message: t(
                                                        'MyCompany.EmailNotValid'
                                                    ),
                                                },
                                            ]}
                                        >
                                            <Input
                                                placeholder={t(
                                                    'MyCompany.PublicContactEmail'
                                                )}
                                                size="large"
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            label={t('Phone')}
                                            name="phone"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: t(
                                                        'errorText.requiredField'
                                                    ),
                                                },
                                            ]}
                                        >
                                            <Input
                                                placeholder={t('Phone')}
                                                size="large"
                                            />
                                        </Form.Item>
                                    </div>
                                    <Form.Item
                                        label={t('Address')}
                                        name="address"
                                        rules={[
                                            {
                                                required: true,
                                                message: t(
                                                    'errorText.requiredField'
                                                ),
                                            },
                                        ]}
                                    >
                                        <Input.TextArea
                                            placeholder={t('Address')}
                                            rows={3}
                                            size="large"
                                            showCount
                                            maxLength={200}
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label={t('MyCompany.Country')}
                                        name="country"
                                        rules={[
                                            {
                                                required: true,
                                                message: t(
                                                    'errorText.requiredField'
                                                ),
                                            },
                                        ]}
                                    >
                                        <Input
                                            placeholder={t('MyCompany.Country')}
                                            size="large"
                                            disabled
                                        />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>
                <ModalDiscardChanges
                    open={openChange}
                    handelOk={isChangeLocation ? handelOkLocation : handelOk}
                    handelClose={() => setOpenChange(false)}
                />
            </div>
        </>
    );
}
const SvgIconPlus = () => (
    <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M28.4999 13.5H16.5001V1.49991C16.5001 0.672089 15.828 0 14.9999 0C14.1721 0 13.5 0.672089 13.5 1.49991V13.5H1.49991C0.672089 13.5 0 14.1721 0 14.9999C0 15.828 0.672089 16.5001 1.49991 16.5001H13.5V28.4999C13.5 29.328 14.1721 30.0001 14.9999 30.0001C15.828 30.0001 16.5001 29.328 16.5001 28.4999V16.5001H28.4999C29.328 16.5001 30.0001 15.828 30.0001 14.9999C30.0001 14.1721 29.328 13.5 28.4999 13.5Z"
            fill="#7B67FB"
        />
    </svg>
);
